<template>
  <div id="app">
    <v-app :class="[$router.currentRoute.name + '-page']">
      <div class="main-view">
        <AppHeader />
        <router-view class="flex-grow-1" :key="$route.fullPath" />
        <AppFooter />
      </div>
      <MediaView v-if="isShowMediaView" />
      <SpinnerList />
      <DialogReport v-model="isShowPopupReport" @action="showReport" />
      <DialogConfirm ref="dialogConfirm" />
      <ChatWrapper v-if="token" ref="ChatFixedBottom"/>
      <ScrollTop v-if="!token"/>
      <Prerendering v-if="prerendering"/>
      <Cordova v-if="isCordova"/>
      <DialogGoogleMap ref="dialogGoogleMap" />
    </v-app>
  </div>
</template>
<script>
import AppHeader from "@/components/AppHeader.vue";
import MediaView from "@/components/MediaView.vue";
import SpinnerList from "@/components/SpinnerList.vue";
import AppFooter from "@/components/AppFooter.vue";
import DialogReport from "@/components/Dialog/DialogReport";
import DialogConfirm from "@/components/Common/DialogConfirm";
import ChatWrapper from "@/components/Chat/ChatWrapper";
import ScrollTop from "@/components/Buttons/ScrollTop";
import Prerendering from "@/components/Common/Prerendering";
import Cordova from "@/components/Common/Cordova";
import DialogGoogleMap from "@/components/Common/DialogGoogleMap"
export default {
  name: "App",
  components: {
    AppHeader,
    SpinnerList,
    MediaView,
    AppFooter,
    DialogReport,
    DialogConfirm,
    ChatWrapper,
    ScrollTop,
    Prerendering,
    Cordova,
    DialogGoogleMap
  },
  metaInfo() {
    let googleSiteVerify = '-gGUH_bV_fX8S3I-AVAJPxe7ROKuSAaSnMvNcOo28tw'
    return {
      title: this.$route.meta.title,
      titleTemplate: "%s | " + this.appendTitle,
      meta: [
        {
          vmid: "description",
          name: "description",
          content: this.$route.meta.description || this.metaDescription,
        },
        {
          vmid: "google-site-verification",
          name: "google-site-verification",
          content: googleSiteVerify,
        },
      ],
      htmlAttrs: {
        lang: this.$language.current.split("_")[0],
      },
    };
  },
  data() {
    return {};
  },
  computed: {
    prerendering() {
      return this.$store.getters.prerendering;
    },
    isShowMediaView() {
      return this.$store.state.toggle.isShowMediaView;
    },
    isShowPopupReport() {
      return this.$store.state.report.isShowPopupReport;
    },
    preloadingImg() {
      return this.$store.state.toggle.preloadingImg;
    },
    watchPreloadingImg() {
      return this.$store.state.toggle.watchPreloadingImg;
    },
    appendTitle() {
      return this.$gettext("BGC - Best golf courses ranking worldwide");
    },
    metaDescription() {
      return this.$gettext(
        "Discover the Golf course ranking worldwide, find out where are the best golf courses in the world, read every reviews of the top golf courses. Ranked by BGC"
      );
    },
    token() {
      return this.$store.state.auth.token;
    },
    isCordova() {
      return window.cordova
    },
  },
  created() {
    this.$store.dispatch("location/setCountryList");
  },
  mounted() {
    this.$store.state.toggle.dialogConfirm = this.$refs.dialogConfirm;
    this.$store.state.toggle.dialogGoogleMap = this.$refs.dialogGoogleMap;
    document.addEventListener("click", this.onClick);
  },
  methods: {
    showReport(val) {
      this.$store.dispatch("setStatusPopup", val);
    },
    onClick(evt) {
      this.$store.commit("setActiveElement", evt.target);
    },
    checkShowHeader() {
      if (
        this.$route.name == "ranking-worldwide" ||
        this.$route.name == "ranking-country" ||
        this.$route.name == "ranking-worldwide-all" ||
        this.$route.name == "ranking-country-all" ||
        this.$route.name == "mediaView" ||
        this.$route.name == "homepage" ||
        this.$route.name == "ranking-zone" ||
        this.$route.name == "ranking-zone-all"
      )
        return false;
      return true;
    },
  },
  watch: {
    isShowMediaView: {
      immediate: true,
      handler(val) {
        let html = document.querySelector("html");
        if (val) {
          html.style.overflow = "hidden";
        } else {
          html.style.overflow = "auto";
        }
      },
    },
    token:{
      handler() {
        if(this.token) {
          const _this = this
          this.$nextTick(() => {
            _this.$store.state.toggle.ChatFixedBottom = _this.$refs.ChatFixedBottom;
          });

        }
      },
      immediate: true
    }
  },
};
</script>
